import React from 'react';
import { Localized } from './Localized';

/**
 * @brief Renders the error page that is shown when something goes wrong.
 */
const ErrorPage = ({ error }) => {
    return (
        <div
            style={{
                display: 'flex',
                height: '100vh',
                width: '100vw',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
            }}
        >
            <div>
                <b>Error</b> <br />
                {getErrorText(error)}
            </div>
        </div>
    );
};

/**
 * @brief Returns a node object with the translated error texts.
 */
function getErrorText(error) {
    const contactStringDe = ' Bitte kontaktieren Sie ch@zellweger.com um Ihren PDF-Report zu erhalten.';
    const contactStringEn = ' Please contact ch@zellweger.com to get your PDF-Report.';
    switch (error) {
        case 'no-access-data':
            return (
                <Localized
                    de={'Es wurden keine Zugangsdaten gefunden.' + contactStringDe}
                    en={'No access data found.' + contactStringEn}
                />
            );
        case 'no-token':
            return (
                <Localized
                    de={'Ihr Zugangsschlüssel konnte nicht auf die PDF-Seite übertragen werden.' + contactStringDe}
                    en={'Your access token could not be applied to the pdf report page.' + contactStringEn}
                />
            );
        case 'server-auth-error':
            return (
                <Localized
                    de={'Ihre Zugangsdaten konnten vom Server nicht verifiziert werden.' + contactStringDe}
                    en={'Your access data could not be authenticated by the server.' + contactStringEn}
                />
            );
        case 'no-metadata':
            return (
                <Localized
                    de={'Für dieses Assessment steht im Moment kein PDF-Report zur Verfügung.' + contactStringDe}
                    en={'There is currently no PDF-Report available for this assessment.' + contactStringEn}
                />
            );
        case 'server-generic-error':
            return (
                <Localized
                    de={'Unbekannte Server-Antwort.' + contactStringDe}
                    en={'Unknown server response.' + contactStringEn}
                />
            );
        default:
            return (
                <Localized de={'Bitte kontaktieren Sie ch@zellweger.com.'} en={'Please contact ch@zellweger.com.'} />
            );
    }
}

export default ErrorPage;
